export default {
  namespaced: true,
  state: {
    services: [],
  },
  getters: {
    services: (state) => state.services,
  },
  actions: {
    async getServices({ commit }) {
      const rs = await fetch(`${process.env.VUE_APP_API_BASE_URL}/services`)
      const data = await rs.json()
      commit('setServices', await data.data)
    },
  },
  mutations: {
    setServices(state, data) {
      state.services = data
    },
  },
}
